import React, { useState } from "react";

const ContactForm = ({ service = "" }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    service: service,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Skickat formulär:", formData);

    // Här kan du t.ex. skicka datan till en backend eller en tjänst som Formspree / Netlify / Zapier
  };

  return (
    <section className="bg-gray-100 p-6 mt-6">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl font-bold mb-4">
          Kontakta oss om {service ? service.toLowerCase() : "våra tjänster"}
        </h2>
        <p className="text-gray-600 mb-6">Fyll i formuläret så återkommer vi inom kort.</p>

        <form onSubmit={handleSubmit} className="space-y-4 text-left">
          <input
            type="text"
            name="name"
            placeholder="Ditt namn"
            value={formData.name}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 p-3 rounded"
          />
          <input
            type="email"
            name="email"
            placeholder="Din e-post"
            value={formData.email}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 p-3 rounded"
          />
          <textarea
            name="message"
            placeholder="Ditt meddelande"
            value={formData.message}
            onChange={handleChange}
            rows="4"
            required
            className="w-full border border-gray-300 p-3 rounded"
          ></textarea>

          {/* Skicka med tjänstnamnet som hidden fält */}
          <input type="hidden" name="service" value={formData.service} />

          <button
            type="submit"
            className="bg-green-600 text-white px-6 py-3 rounded hover:bg-green-700 transition"
          >
            Skicka
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
